// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2hOZO","selects":"Documents_selects__2PtEE"};